import Axios from 'axios';
import { isJwtExpired } from '../auth/jwt/tokenUtils';

// Create axios instance
const axios = Axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
    timeout: 10000,
});

// Request interceptor
const authRequestInterceptor = async (config: any) => {
    config.headers = { ...config.headers };
    config.headers.Accept = 'application/json';

    // Add auth token if available
    const authData = localStorage.getItem('auth');
    if (authData) {
        try {
            const { token } = JSON.parse(authData);
            if (token) {
                if (isJwtExpired(token)) {
                    localStorage.removeItem('auth');
                    if (window.location.pathname !== '/login') {
                        window.location.href = '/login';
                    }
                    return Promise.reject(new Error('Session expired'));
                }
                config.headers.Authorization = `Bearer ${token}`;
            }
        } catch (error) {
            console.error('Error parsing auth data:', error);
        }
    }

    return config;
};

// Response interceptor - Handle errors
axios.interceptors.request.use(authRequestInterceptor);

axios.interceptors.response.use(
    (response) => response,
    (error) => {
        // Handle 401 Unauthorized - Token expired or invalid
        if (error.response?.status === 401) {
            localStorage.removeItem('auth');
            window.location.href = '/login';
        }

        // Handle 403 Forbidden
        if (error.response?.status === 403) {
            console.error('Access forbidden');
        }

        // Handle 500 Server Error
        if (error.response?.status === 500) {
            console.error('Server error occurred');
        }

        return Promise.reject(error);
    }
);

export default axios;
